import type { FilterSelectOption } from '../../components/FilterSelect/types';
import type {
  OrganizationTracks,
  OrganizationTracksVariables,
} from './graphql/types/OrganizationTracks';
import type {
  OrganizationTracksWithCoursePreviews,
  OrganizationTracksWithCoursePreviewsVariables,
} from './graphql/types/OrganizationTracksWithCoursePreviews';

export type TracksNode =
  | OrganizationTracks
  | OrganizationTracksWithCoursePreviews;
export type TracksVariables =
  | OrganizationTracksVariables
  | OrganizationTracksWithCoursePreviewsVariables;

export enum tracksQueryTypeEnum {
  BASE,
  WITH_COURSE_PREVIEWS,
}

export interface UseOrganizationTracksProps {
  queryType?: tracksQueryTypeEnum;
  batchSize?: number;
  filterOptions?: FilterSelectOption[];
  selectedTracks?: number[];
}
